module.exports = __webpack_public_path__ + "img/2.0c9937b9.jpg";